<h3 class="ui primary header">
  Upload Proof of Payment
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="ui form" [formGroup]="uploadProofOfPaymentForm">
      <div class="field" [ngClass]="displayFieldCss('nameOfBank')">
        <label class="required">Bank Name</label>
        <input
          #input
          formControlName="nameOfBank"
          type="text"
          placeholder="Enter bank name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('nameOfBank')"
          errorMsg="Please enter bank name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('nameOfBankBranch')">
        <label>Bank Branch</label>
        <input
          formControlName="nameOfBankBranch"
          type="text"
          placeholder="Enter bank branch"
        />
        <app-field-error-display
          [displayError]="isFieldValid('nameOfBankBranch')"
          errorMsg="Please enter bank branch"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('bankCountry')">
        <label>Bank Country</label>
        <input
          formControlName="bankCountry"
          type="text"
          placeholder="Enter bank country"
        />
        <app-field-error-display
          [displayError]="isFieldValid('bankCountry')"
          errorMsg="Please enter bank country"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('tellerNumber')">
        <label class="required">Teller Number</label>
        <input
          formControlName="tellerNumber"
          type="text"
          placeholder="Enter teller number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tellerNumber')"
          errorMsg="Please enter teller number"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('payerName')">
        <label class="required">Payer's Name</label>
        <input
          formControlName="payerName"
          type="text"
          placeholder="Enter teller  payer's name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('payerName')"
          errorMsg="Please enter payer's name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('payerEmail')">
        <label class="required">Payer's Email</label>
        <input
          formControlName="payerEmail"
          type="text"
          placeholder="Enter teller  payer's email"
        />
        <app-field-error-display
          [displayError]="isFieldValid('payerEmail')"
          errorMsg="Please enter payer's email"
        >
        </app-field-error-display>
      </div>

      <div class="field">
        <label>Description</label>
        <textarea
          rows="2"
          formControlName="description"
          type="text"
          placeholder="Enter description"
        ></textarea>
      </div>

      <div class="field" [ngClass]="displayFieldCss('file')">
        <label class="required">Select File</label>
        <input
          #uploadDoc
          type="file"
          formControlName="file"
          accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
          #uploader
          (change)="onFileSelected($event)"
          placeholder="Browse for documents"
          onclick="value = null"
        />
        <app-field-error-display
          [displayError]="isFieldValid('file')"
          errorMsg="Please select file"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions" style="border: none; background-color: #fff">
  <button class="ui button cancel-modal" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [disabled]="!uploadProofOfPaymentForm.valid"
    (click)="save()"
    [ngClass]="{ 'yellow loading': pending }"
    autofocus
  >
    Save
  </button>
</div>
